<template>
  <div>
    <h1 class="display-3 ma-5 pa-5 indigo darken-1 white--text rounded-tl-xl">
      Agenda
    </h1>
    <v-divider></v-divider>

    <div class="ma-5 pa-5">
      <h1 class="display-1 mb-5">Filtre por barbeiro</h1>
      <v-select
        :items="barbeiros"
        item-text="nome"
        item-value="id"
        v-model="barbeiroFiltrado"
        label="Escolha o filtro"
        @change="buscarAgenda"
        dense
      ></v-select>
      <br />
      <TravarHorarioDialog @recarregarLista="atualizar" />
      <AgendarHorarioDialog @recarregarLista="atualizar" />
      <v-btn class="success" block @click="atualizar">
        Atualizar
      </v-btn>
    </div>
    <br />
    <v-sheet height="64">
      <v-toolbar flat color="white">
        <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
          Hoje
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="prev">
          <v-icon small>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn fab text small color="grey darken-2" @click="next">
          <v-icon small>mdi-chevron-right</v-icon>
        </v-btn>
        <v-toolbar-title v-if="$refs.calendar">
          {{ $refs.calendar.title }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-menu bottom right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
              <span>{{ typeToLabel[type] }}</span>
              <v-icon right>mdi-menu-down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="type = 'day'">
              <v-list-item-title>Dia</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'week'">
              <v-list-item-title>Semana</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'month'">
              <v-list-item-title>Mês</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = '4day'">
              <v-list-item-title>4 dias</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar>
    </v-sheet>
    <v-sheet height="600">
      <v-calendar
        ref="calendar"
        v-model="focus"
        color="primary"
        :events="events"
        :type="type"
        locale="pt-BR"
        @click:event="showEvent"
        @click:more="viewDay"
        @click:date="viewDay"
        first-time="06:00"
      ></v-calendar>
      <v-menu
        v-model="selectedOpen"
        :close-on-content-click="false"
        :activator="selectedElement"
        offset-x
      >
        <v-card color="grey lighten-4" min-width="350px" flat>
          <v-toolbar :color="selectedEvent.color" dark>
            <v-btn icon @click="apagarAgendamento">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-toolbar-title
              v-html="'Cliente: ' + selectedEvent.name"
            ></v-toolbar-title>
            <v-spacer></v-spacer>

            <!--<v-btn icon>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>-->
          </v-toolbar>
          <v-card-text>
            <div v-if="typeof selectedEvent.cliente !== 'undefined'">
              <p>
                <span>
                  <small>Cliente:</small>
                  <strong>{{ selectedEvent.cliente.nome }}</strong></span
                >
              </p>
              <p>
                <span>
                  <small>Telefone:</small>
                  <strong
                    ><a :href="mensagem(selectedEvent)" target="_blank">{{
                      selectedEvent.cliente.telefone
                    }}</a></strong
                  ></span
                >
              </p>
              <p>
                <span>
                  <small>Email:</small>
                  <strong>{{ selectedEvent.cliente.email }}</strong></span
                >
              </p>
              <v-divider class="mb-3"></v-divider>
              <p>
                <span>
                  <small>Barbeiro:</small>
                  <strong>{{ selectedEvent.barbeiro.nome }}</strong></span
                >
              </p>
              <p>
                <span>
                  <small>Serviço:</small>
                  <strong
                    >{{ selectedEvent.servico.descricao }} -
                    {{ selectedEvent.servico.tempo }} - R$
                    {{ selectedEvent.servico.preco }}</strong
                  ></span
                >
              </p>
              <p>
                <span>
                  <small>Horário:</small>
                  <strong
                    >{{ selectedEvent.start.split(" ")[1] }} até
                    {{ selectedEvent.end.split(" ")[1] }}</strong
                  ></span
                >
              </p>
              <p>
                <span>
                  <small>Código: {{ selectedEvent.id }}</small>
                </span>
              </p>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="mr-2" color="secondary" @click="selectedOpen = false">
              Fechar
            </v-btn>
            <AgendaAjuste :itemPassado="selectedEvent" @attAgenda="atualizar">
            </AgendaAjuste>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-sheet>
  </div>
</template>

<script>
//import firebase from 'firebase'
import { mapGetters } from "vuex";

import { refAgenda, refBarbeiros } from "@/firebaseConfig";
import TravarHorarioDialog from "./Components/TravarHorarioDialog";
import AgendarHorarioDialog from "./Components/AgendarHorarioDialog";
import AgendaAjuste from "./Components/AgendaAjuste";

export default {
  components: {
    TravarHorarioDialog,
    AgendaAjuste,
    AgendarHorarioDialog,
  },
  data() {
    return {
      refAgenda: refAgenda,
      refBarbeiros: refBarbeiros,
      today: new Date().toISOString().substr(0, 10),
      barbeiroFiltrado: "",
      barbeiros: [],
      events: [],
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      focus: "",
      type: "month",
      typeToLabel: {
        month: "Month",
        week: "Week",
        day: "Day",
        "4day": "4 Days",
      },
      names: [
        "Meeting",
        "Holiday",
        "PTO",
        "Travel",
        "Event",
        "Birthday",
        "Conference",
        "Party",
      ],
      colors: [
        "blue",
        "indigo",
        "deep-purple",
        "cyan",
        "green",
        "orange",
        "grey darken-1",
      ],
    };
  },

  mounted() {
    //this.$refs.calendar.scrollToTime('08:00');
    this.carregarAgenda();
    this.carregarBarbeiros();
    this.$refs.calendar.checkChange();
  },
  computed: {
    ...mapGetters(["getCurrentUser", "isUserAuth"]),
  },
  methods: {
    mensagem(item) {
      var hora = item.start.substring(item.start.length - 5);
      var dia = item.start.split("-")[2];
      dia = dia.substring(0, 2);
      var telefone = item.cliente.telefone
        .replace("(", "")
        .replace(")", "")
        .replace("-", "");
      var servico = item.servico.descricao;
      // console.log(hora);
      // console.log(dia);
      let text = `https://api.whatsapp.com/send?phone=55${telefone}&text=Olá, gostaria de confirmar seu agendamento para às ${hora}, neste dia ${dia} na Barbearia Lisboa, para o serviço de ${servico}&app_absent=0`;
      return text;
    },
    buscarAgenda() {
      let dias = 15 * (24 * 60 * 60 * 1000);
      let dataMinima = new Date().getTime();
      dataMinima = dataMinima - dias;
      this.events = [];

      //caso seja nível 3 ou mais, pode ver TUDO, carrega este mesmo

      if (this.$store.getters.getPermissoes[this.getCurrentUser.lvl] >= 3) {
        this.refAgenda
          .where("barbeiro.id", "==", this.barbeiroFiltrado)
          .where("dataQuery", ">=", dataMinima)
          .get()
          .then((snap) => {
            snap.forEach((doc) => {
              this.tratarAgendamento(doc);
            });
          });
      } else {
        //caso seja nível menor, não pode ver tudo...
        this.refAgenda
          .where("barbeiro.email", "==", this.getCurrentUser.email)
          .where("dataQuery", ">=", dataMinima)
          .get()
          .then((snap) => {
            snap.forEach((doc) => {
              this.tratarAgendamento(doc);
            });
          });
      }
    },
    carregarAgenda() {
      let dias = 15 * (24 * 60 * 60 * 1000);
      let dataMinima = new Date().getTime();
      dataMinima = dataMinima - dias;
      this.events = [];

      //console.log(this.$store.getters.getPermissoes[this.getCurrentUser.lvl])

      if (this.$store.getters.getPermissoes[this.getCurrentUser.lvl] >= 3) {
        this.refAgenda
          .where("dataQuery", ">=", dataMinima)
          .get()
          .then((snap) => {
            snap.forEach((doc) => {
              this.tratarAgendamento(doc);
            });
          });
      } else {
        //alert(this.getCurrentUser.id)
        //caso seja nível menor, não pode ver tudo...
          console.log(this.getCurrentUser)
          this.refAgenda
          .where("barbeiro.email", "==", this.getCurrentUser.email)
          .where("dataQuery", ">=", dataMinima)
          .get()
          .then((snap) => {
            snap.forEach((doc) => {
              this.tratarAgendamento(doc);
            });
          });
        
        
      }
    },
    tratarAgendamento(doc) {
      let agendamento = doc.data();
      if (doc.data().start.length != 16 || doc.data().end.length != 16) {
        //console.log("remover", doc.data());
      } else {
        console.log(" ------ ");
        console.log("Nome", agendamento.name + " " + agendamento.id);
        console.log("Start", agendamento.start);
        console.log("End", agendamento.end);
        agendamento.start = this.corrigirData(doc.data().start);
        agendamento.end = this.corrigirData(doc.data().end);
        //console.log(doc.data());
        this.events.push({ ...agendamento });
      }
    },
    corrigirData(data) {
      if (data.includes("T")) {
        return data.replace("T", " ");
      } else {
        return data;
      }
    },

    carregarBarbeiros() {
      this.refBarbeiros.get().then((snap) => {
        snap.forEach((doc) => {
          // console.log(doc.data());
          this.barbeiros.push({ ...doc.data() });
        });
      });
    },

    apagarAgendamento() {
      //this.selectedEvent.id
      if (confirm("Deseja cancelar este agendamento?")) {
        this.refAgenda
          .doc(this.selectedEvent.id)
          .delete()
          .then(() => {
            // this.buscarAgenda();
            this.atualizar();
            this.selectedOpen = false;
          });
      }
    },

    atualizar() {
      console.log(this.barbeiroFiltrado);
      if (this.barbeiroFiltrado !== "" ) {
        this.buscarAgenda();
      } else {
        this.carregarAgenda();
      }

      try {
        this.selectedOpen = false;
      } catch (err) {
        console.log(err);
      }
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },

    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => (this.selectedOpen = true), 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },

    updateRange({ start, end }) {
      const events = [];

      const min = new Date(`${start.date}T00:00:00`);
      const max = new Date(`${end.date}T23:59:59`);
      const days = (max.getTime() - min.getTime()) / 86400000;
      const eventCount = this.rnd(days, days + 20);

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0;
        const firstTimestamp = this.rnd(min.getTime(), max.getTime());
        const first = new Date(firstTimestamp - (firstTimestamp % 900000));
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
        const second = new Date(first.getTime() + secondTimestamp);

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start: first,
          end: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: !allDay,
        });
      }

      this.events = events;
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
  },
};
</script>

<style lang="scss" scoped></style>
